export default __webpack_public_path__ + "static/media/geofence.199102a7.svg";